// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__37NL7","signatureBlock":"Footer_signatureBlock__Paq5p","signature":"Footer_signature__1po6O"};